var _path, _path2, _path3, _path4, _rect, _rect2, _circle, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTdtbpn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4511 7.22681C9.50613 7.22681 4.6747 12.0582 4.6747 18.0032V23.1939C4.6747 24.2895 4.20772 25.9598 3.65094 26.8938L1.58546 30.3243C0.310249 32.4436 1.19032 34.7965 3.52522 35.5868C11.2663 38.1731 19.618 38.1731 27.3591 35.5868C29.5323 34.8683 30.4842 32.3 29.2988 30.3243L27.2334 26.8938C26.6945 25.9598 26.2276 24.2895 26.2276 23.1939V18.0032C26.2276 12.0762 21.3782 7.22681 15.4511 7.22681Z",
    stroke: "black",
    strokeWidth: 1.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7724 7.74742C18.2156 7.58578 17.6409 7.46005 17.0482 7.38821C15.324 7.17268 13.6716 7.29841 12.127 7.74742C12.6478 6.41833 13.941 5.48438 15.4497 5.48438C16.9584 5.48438 18.2516 6.41833 18.7724 7.74742Z",
    stroke: "black",
    strokeWidth: 1.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5401 36.6118C20.5401 39.5753 18.1154 42 15.1519 42C13.6791 42 12.3141 41.3894 11.3442 40.4195C10.3743 39.4496 9.76367 38.0846 9.76367 36.6118",
    stroke: "black",
    strokeWidth: 1.88,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 32C14 33 16 33 19 32",
    stroke: "black",
    strokeWidth: 1.88,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 1.1,
    width: 25.8,
    height: 25.8,
    rx: 12.9,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 1.1,
    width: 25.8,
    height: 25.8,
    rx: 12.9,
    stroke: "white",
    strokeWidth: 1.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 14,
    r: 10,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4211 12.2069C27.0848 12.2069 26.7775 12.4706 26.7924 12.8065C26.8083 13.1664 26.5213 13.4631 26.165 13.4631H24.9088C24.5619 13.4631 24.2808 13.1819 24.2808 12.835C24.2808 12.4881 23.9996 12.2069 23.6527 12.2069H22.3965C21.8993 12.2069 21.4214 12.2895 20.9757 12.4416C19.2448 13.0324 18 14.6725 18 16.6035C18 19.0316 19.9684 21 22.3965 21C22.5441 21 25.63 21.0202 26.5416 17.9039C26.8679 16.7885 27.821 15.9754 28.9832 15.9754H31.5664C32.2602 15.9754 32.8226 15.4129 32.8226 14.7192V13.4631C32.8226 12.7693 32.2602 12.2069 31.5664 12.2069H27.4211Z",
    stroke: "black",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3962 18.3054C21.4572 18.3054 20.6943 17.5425 20.6943 16.6035C20.6943 15.6645 21.4572 14.9016 22.3962 14.9016C23.3352 14.9016 24.0981 15.6645 24.0981 16.6035C24.0981 17.5425 23.3352 18.3054 22.3962 18.3054Z",
    stroke: "black",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4111 7.18232V8.43848",
    stroke: "black",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7471 8.80636L23.6353 9.69458",
    stroke: "black",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0757 8.80636L27.1875 9.69458",
    stroke: "black",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTdtbpn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TDTBPN.77ff879b.svg";
export { ForwardRef as ReactComponent };